import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from '@/i18n/locales/en'
import esLocale from '@/i18n/locales/es'


Vue.use(VueI18n);


export default new VueI18n({
  locale: 'en', // set locale
  fallbackLocale: 'en',
  messages: {
    en: enLocale,
    es: esLocale
  }
});

//i18n.setLocaleMessage('en', appMessagesEn);
//elLocale.use(elMessagesEn);




// WEBPACK FOOTER //
// ./src/i18n/index.js